import { render, staticRenderFns } from "./PendingOrders.vue?vue&type=template&id=bce8a0ae&"
import script from "./PendingOrders.vue?vue&type=script&lang=js&"
export * from "./PendingOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PendingOrders.vue"
export default component.exports